import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-obsidian text-white" data-id="element-80" data-mp="3gezcj1s77n03">
      <div className="mx-auto max-w-4xl px-5 py-14 text-center" style={{
      paddingTop: "22px",
      paddingBottom: "15px"
    }} data-id="element-81" data-mp="3ghc4m7ro7dqv">
        <p className="text-xs font-bold uppercase tracking-[0.3em] text-aqua" data-id="element-82" data-mp="36pfufycb7x6a">Sigma Smart™</p>
        <p className="mt-3 font-display text-3xl font-extrabold uppercase leading-none" data-id="element-83" data-mp="3uf0obca04euc">
          Sistema Triatlón Completo™
        </p>
        <p className="mt-3 text-sm font-semibold uppercase tracking-wider text-white/70" data-id="element-84" data-mp="37o5ytxdtvcu">
          Entrena con más estructura. Organiza tu preparación. Afronta tu próximo desafío con un plan más claro.
        </p>
        <p className="mt-2 text-sm text-white/50" data-id="element-85" data-mp="3qc3z32pyhkhf">
          Un sistema para organizar tu preparación desde los fundamentos del entrenamiento hasta la estrategia y el día de competición.
        </p>

        <a href="mailto:soporte.sigmasmart@gmail.com" className="mt-8 inline-flex items-center gap-2 text-sm text-white/75 transition-colors duration-150 ease-out hover:text-white" data-id="element-86" data-mp="2ez1nkm2prl44">
          <MailIcon className="h-4 w-4 text-electric" aria-hidden="true" data-id="element-87" data-mp="3gbinuv867u3e" /> soporte.sigmasmart@gmail.com
        </a>

        <nav aria-label="Legal" className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/45" data-id="element-88" data-mp="3v8htwendjevr">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-89" data-mp="3q7byua68rfj2">Términos y condiciones</a>
          <span aria-hidden="true" data-id="element-90" data-mp="80ntcj7a4qcv">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-91" data-mp="32w1tqajr697">Política de privacidad</a>
          <span aria-hidden="true" data-id="element-92" data-mp="hriipwfto62j">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-93" data-mp="ctqo2unsm5un">Soporte</a>
        </nav>

        <p className="mt-8 text-xs text-white/35" data-id="element-94" data-mp="qt04nvfwv1z5">© 2026 SIGMA SMART™ — Todos los derechos reservados</p>
      </div>
    </footer>;
}